import { PricelistPeriodDetailPage } from '@/features/pricelist-period/pages/PricelistPeriodDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/period/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistPeriodDetailPage,
})
